module.exports = __webpack_public_path__ + "img/Kedah.c8cdcbf7.png";